export default "__VITE_ASSET__C1jwzL0c__"